import type { PathCommand } from '@/lib/elements/types/path-command'

export function mirrorPathCommands(
  commands: PathCommand[],
  mirror: { x?: boolean; y?: boolean },
  bounds?: { width: number; height: number }
): PathCommand[] {
  const w = bounds?.width ?? 0
  const h = bounds?.height ?? 0

  return commands.map((cmd) => {
    if ('moveTo' in cmd) {
      return {
        moveTo: {
          x: mirror.x ? w - cmd.moveTo.x : cmd.moveTo.x,
          y: mirror.y ? h - cmd.moveTo.y : cmd.moveTo.y,
        },
      }
    } else if ('lineTo' in cmd) {
      return {
        lineTo: {
          x: mirror.x ? w - cmd.lineTo.x : cmd.lineTo.x,
          y: mirror.y ? h - cmd.lineTo.y : cmd.lineTo.y,
        },
      }
    } else if ('curveTo' in cmd) {
      const ct = cmd.curveTo
      const out: typeof ct = {
        controlX: mirror.x ? w - ct.controlX : ct.controlX,
        controlY: mirror.y ? h - ct.controlY : ct.controlY,
        x: mirror.x ? w - ct.x : ct.x,
        y: mirror.y ? h - ct.y : ct.y,
      }

      if (typeof ct.controlX2 === 'number' && typeof ct.controlY2 === 'number') {
        out.controlX2 = mirror.x ? w - ct.controlX2 : ct.controlX2
        out.controlY2 = mirror.y ? h - ct.controlY2 : ct.controlY2
      }

      if (typeof ct.deltaX === 'number' && typeof ct.deltaY === 'number') {
        out.deltaX = mirror.x ? w - ct.deltaX : ct.deltaX
        out.deltaY = mirror.y ? h - ct.deltaY : ct.deltaY
      }

      return { curveTo: out }
    }

    return cmd
  })
}
